import React, { useEffect, useState } from 'react'
import { EligibilityCheck, VacancyCheck } from './TetPreview';
import { config } from '../../../CommonUtilities/CommonUrl/CommonUrls';
import { CommonAxiosGet } from '../../../CommonUtilities/CommonAxios/CommonAxios';
import { CommonPageHeading } from '../../../CommonUtilities/CommonHeading/CommonPageHeading';

export default function ViewVacancies() {

    const [vacancyData, setVacancyData] = useState([]);
            const getdistVacancy = () => {
            let villUrl = config.url.CONTEXT_READ_URL + "district-wise-vacancies";
            CommonAxiosGet(villUrl).then((response) => {
                if (response?.data.status === true) {
                    setVacancyData(response?.data?.data)
                }
                else {
                    setVacancyData([])
                }
            });
        };
         const [eligibleData, setEligibleData] = useState([]);
            const getEligibleData = () => {
            let villUrl = config.url.CONTEXT_READ_URL + "candidate-eligibilty-data";
            CommonAxiosGet(villUrl).then((response) => {
                if (response?.data.status === true) {
                    setEligibleData(response?.data?.data)
                }
                else {
                    setEligibleData([])
                }
            });
        };
          useEffect(() => {
                getdistVacancy();
                getEligibleData();
            }, [])
        
  return (
    <div>
    <CommonPageHeading 
    
    heading={(<>Vacancies - <span style={{color:'tomato'}}>{vacancyData?.[0]?.dist_name} </span></>)}
    />
      <VacancyCheck vacancyData={vacancyData} />
      <EligibilityCheck eligibleData={eligibleData} />
    </div>
  )
}
